import { IPlan, PlansStore } from "./types";
import { useQuery } from "@common/utils/use-query";
import { formatPlansData } from "./utils";

export const plansStore: PlansStore = {
  useGetPlans({ enabled } = { enabled: true }) {
    const res = useQuery<unknown, unknown, IPlan[]>(
      { url: "/plan" },
      {
        enabled,
        refetchInterval: 1000 * 60 * 60 * 12, // reload every 12 hours
        refetchIntervalInBackground: true,
        refetchOnWindowFocus: true,
      },
    );

    if (res.data) {
      res.data = formatPlansData(res.data);
    }

    return res;
  },

  // Not used atm
  useGetPlan(alias, { enabled } = { enabled: true }) {
    return useQuery({ url: `/plan/${alias}` }, { enabled });
  },
};
